import { useState } from "react";

import { FloatingWindow } from "src/base-components/FloatingWindow/FloatingWindow";
import { mdService } from "src/base-components/TextEditor/MarkdownService";
import {
  buildOpenStringValueCallback,
  isLargeStringValue,
  trimLargeString,
} from "src/dataTable/TableUtils";

export const MultilineDataValue: React.FC<{
  fieldName: string;
  value: string;
  preserveFormattingForLargeStrings?: boolean;
}> = ({ fieldName, value, preserveFormattingForLargeStrings = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const shouldTrim =
    !preserveFormattingForLargeStrings && isLargeStringValue(value, "multi");
  const valueToUse = shouldTrim ? trimLargeString(value, "multi") : value;

  const htmlValue = mdService.toHtml(valueToUse);

  return (
    <div className="relative min-w-0 flex-1" data-loc="multiline-content">
      <p
        //skipcq: JS-0440
        dangerouslySetInnerHTML={{
          __html: htmlValue,
        }}
        className="tktl-markdown line-clamp-5 break-words text-left font-inter-normal-12px text-gray-800"
        data-loc="markdown-preview"
      />

      <FloatingWindow
        button={
          <button
            className="ml-auto flex cursor-pointer items-center font-inter-normal-12px text-indigo-700 underline"
            data-loc="see-more-button"
            onClick={() => {
              if (shouldTrim) {
                buildOpenStringValueCallback(value)();
              } else {
                setIsOpen(true);
              }
            }}
          >
            See more
          </button>
        }
        isOpen={isOpen}
        maximizable={false}
        pinnable={false}
        title={fieldName}
        resizeable
        onClose={() => setIsOpen(false)}
      >
        <div className="flex h-full flex-col">
          <div
            //skipcq: JS-0440
            dangerouslySetInnerHTML={{
              __html: htmlValue,
            }}
            className="tktl-markdown decideScrollbar h-full flex-1 break-words py-3 pr-1 pl-2 font-inter-normal-12px text-gray-800"
          />
          <div className="mt-3" />
        </div>
      </FloatingWindow>
    </div>
  );
};
